"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M16.501 13.016H13.661C14.079 13.865 13.98 14.939 13.349 15.671C13.256 15.779 13.145 15.898 13.037 16.016H16.501C17.33 16.016 18.001 15.345 18.001 14.516C18.001 13.688 17.33 13.016 16.501 13.016ZM17.751 8.016H6.501C5.673 8.016 5.001 8.688 5.001 9.516C5.001 9.565 5.011 9.611 5.016 9.658C5.83 9.251 6.637 9.037 7.445 9.037C8.896 9.037 10.346 9.688 11.842 11.016H16.501C17.33 11.016 18.001 10.345 18.001 9.516V8.266C18.001 8.128 17.889 8.016 17.751 8.016ZM7.44 13.008C6.859 13.02 6.397 13.478 6.408 14.032C6.419 14.586 6.899 15.025 7.481 15.014C8.063 15.002 8.525 14.543 8.514 13.99C8.502 13.436 8.022 12.996 7.44 13.008ZM9.568 14.023C9.568 12.922 8.63 12.029 7.474 12.029C6.317 12.029 5.379 12.922 5.379 14.023C5.379 15.125 6.317 16.018 7.474 16.018C8.63 16.018 9.568 15.125 9.568 14.023ZM12.591 15.018C11.597 16.172 9.672 18 7.46 18C5.249 18 3.324 16.172 2.33 15.018C1.89 14.508 1.89 13.692 2.33 13.181C3.324 12.028 5.249 10.021 7.46 10.021C9.672 10.021 11.597 12.028 12.591 13.181C13.031 13.692 13.031 14.508 12.591 15.018ZM16.501 6H5.251C5.113 6 5.001 5.889 5.001 5.75V4.5C5.001 3.672 5.673 3 6.501 3H16.501C17.33 3 18.001 3.672 18.001 4.5C18.001 5.329 17.33 6 16.501 6Z",
    fill: "#727B7F"
  }));
};